import client from './client';

/* ── Types ─────────────────────────────────────────────────── */
export interface WebUser {
  username:  string;
  email:     string;
  roleId:    number | null;
  roleName:  string;
  isActive:  boolean;
  createdAt: string;
}

export interface WebRole {
  id:          number;
  name:        string;
  description: string;
  permissions: string[];
}

export const ALL_PERMISSIONS = [
  'users', 'roles',
  'families', 'families.delete', 'members.delete',
  'subscriptions',
  'cemetery', 'cemetery.delete',
  'export',
] as const;
export type Permission = (typeof ALL_PERMISSIONS)[number];

/* ── User API ───────────────────────────────────────────────── */
export const listUsers = async (): Promise<WebUser[]> => {
  const { data } = await client.get<{ data: { users: WebUser[] } }>('/users');
  return data.data.users;
};

export const saveUser = async (payload: {
  username: string;
  email:    string;
  roleId:   number | null;
  isActive: boolean;
  password?: string;
}): Promise<WebUser[]> => {
  const { data } = await client.post<{ data: { users: WebUser[] } }>('/users', payload);
  return data.data.users;
};

export const deleteUser = async (username: string): Promise<void> => {
  await client.delete(`/users/${encodeURIComponent(username)}`);
};

/* ── Role API ───────────────────────────────────────────────── */
export const listRoles = async (): Promise<WebRole[]> => {
  const { data } = await client.get<{ data: { roles: WebRole[] } }>('/roles');
  return data.data.roles;
};

export const saveRole = async (payload: {
  id?:         number;
  name:        string;
  description: string;
  permissions: string[];
}): Promise<WebRole[]> => {
  const { data } = await client.post<{ data: { roles: WebRole[] } }>('/roles', payload);
  return data.data.roles;
};

export const deleteRole = async (id: number): Promise<void> => {
  await client.delete(`/roles/${id}`);
};
